// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_person_category.ml",
      138,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "PersonCategory"
                          ]]
                      },
                      "V1"
                    ]]
                },
                "Control"
              ]]
          },
          "Tax"
        ]]
    });

const Tax = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_person_category.ml",
      241,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "PersonCategory"
                    ]]
                },
                "V1"
              ]]
          },
          "Control"
        ]]
    });

const Control = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_person_category.ml",
      342,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "PersonCategory"
              ]]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_person_category.ml",
      441,
      12
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "PersonCategory"
        ]]
    });

const PersonCategory = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_person_category.ml",
      536,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.tax.control.v1.PersonCategory";
}

function to_int(param) {
  switch (param) {
    case /* PERSON_CATEGORY_UNSPECIFIED */0 :
        return 0;
    case /* PERSON_CATEGORY_PENSIONER_AGE */1 :
        return 11;
    case /* PERSON_CATEGORY_PENSIONER_DUTY */2 :
        return 12;
    case /* PERSON_CATEGORY_DISABLED_GROUP_1 */3 :
        return 21;
    case /* PERSON_CATEGORY_DISABLED_GROUP_1_PERMANENT */4 :
        return 22;
    case /* PERSON_CATEGORY_DISABLED_GROUP_2 */5 :
        return 23;
    case /* PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT */6 :
        return 24;
    case /* PERSON_CATEGORY_DISABLED_GROUP_3 */7 :
        return 25;
    case /* PERSON_CATEGORY_VETERAN */8 :
        return 40;
    case /* PERSON_CATEGORY_GUARDIAN_DISABLED */9 :
        return 50;
    case /* PERSON_CATEGORY_GUARDIAN_ORPHANED */10 :
        return 60;
    case /* PERSON_CATEGORY_ADOPTER */11 :
        return 70;
    case /* PERSON_CATEGORY_CHILDREN */12 :
        return 80;
    case /* PERSON_CATEGORY_MATERNITY */13 :
        return 90;
    case /* PERSON_CATEGORY_CONVICT */14 :
        return 100;
    case /* PERSON_CATEGORY_MOTHER_MANY */15 :
        return 110;
    case /* PERSON_CATEGORY_STUDENT */16 :
        return 120;
    
  }
}

function from_int_exn(n) {
  if (n >= 71) {
    if (n >= 100) {
      if (n !== 110) {
        if (n !== 120) {
          if (n >= 101) {
            return Ocaml_protoc_plugin__Result.raise({
                        NAME: "Unknown_enum_value",
                        VAL: n
                      });
          } else {
            return /* PERSON_CATEGORY_CONVICT */14;
          }
        } else {
          return /* PERSON_CATEGORY_STUDENT */16;
        }
      } else {
        return /* PERSON_CATEGORY_MOTHER_MANY */15;
      }
    } else if (n !== 80) {
      if (n !== 90) {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      } else {
        return /* PERSON_CATEGORY_MATERNITY */13;
      }
    } else {
      return /* PERSON_CATEGORY_CHILDREN */12;
    }
  }
  if (n >= 50) {
    if (n > 69 || n < 51) {
      if (n >= 70) {
        return /* PERSON_CATEGORY_ADOPTER */11;
      } else {
        return /* PERSON_CATEGORY_GUARDIAN_DISABLED */9;
      }
    } else if (n !== 60) {
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
    } else {
      return /* PERSON_CATEGORY_GUARDIAN_ORPHANED */10;
    }
  }
  if (n < 11) {
    if (n !== 0) {
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
    } else {
      return /* PERSON_CATEGORY_UNSPECIFIED */0;
    }
  }
  if (n >= 41) {
    return Ocaml_protoc_plugin__Result.raise({
                NAME: "Unknown_enum_value",
                VAL: n
              });
  }
  switch (n) {
    case 11 :
        return /* PERSON_CATEGORY_PENSIONER_AGE */1;
    case 12 :
        return /* PERSON_CATEGORY_PENSIONER_DUTY */2;
    case 21 :
        return /* PERSON_CATEGORY_DISABLED_GROUP_1 */3;
    case 22 :
        return /* PERSON_CATEGORY_DISABLED_GROUP_1_PERMANENT */4;
    case 23 :
        return /* PERSON_CATEGORY_DISABLED_GROUP_2 */5;
    case 24 :
        return /* PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT */6;
    case 25 :
        return /* PERSON_CATEGORY_DISABLED_GROUP_3 */7;
    case 13 :
    case 14 :
    case 15 :
    case 16 :
    case 17 :
    case 18 :
    case 19 :
    case 20 :
    case 26 :
    case 27 :
    case 28 :
    case 29 :
    case 30 :
    case 31 :
    case 32 :
    case 33 :
    case 34 :
    case 35 :
    case 36 :
    case 37 :
    case 38 :
    case 39 :
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
    case 40 :
        return /* PERSON_CATEGORY_VETERAN */8;
    
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* PERSON_CATEGORY_UNSPECIFIED */0 :
        return "PERSON_CATEGORY_UNSPECIFIED";
    case /* PERSON_CATEGORY_PENSIONER_AGE */1 :
        return "PERSON_CATEGORY_PENSIONER_AGE";
    case /* PERSON_CATEGORY_PENSIONER_DUTY */2 :
        return "PERSON_CATEGORY_PENSIONER_DUTY";
    case /* PERSON_CATEGORY_DISABLED_GROUP_1 */3 :
        return "PERSON_CATEGORY_DISABLED_GROUP_1";
    case /* PERSON_CATEGORY_DISABLED_GROUP_1_PERMANENT */4 :
        return "PERSON_CATEGORY_DISABLED_GROUP_1_PERMANENT";
    case /* PERSON_CATEGORY_DISABLED_GROUP_2 */5 :
        return "PERSON_CATEGORY_DISABLED_GROUP_2";
    case /* PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT */6 :
        return "PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT";
    case /* PERSON_CATEGORY_DISABLED_GROUP_3 */7 :
        return "PERSON_CATEGORY_DISABLED_GROUP_3";
    case /* PERSON_CATEGORY_VETERAN */8 :
        return "PERSON_CATEGORY_VETERAN";
    case /* PERSON_CATEGORY_GUARDIAN_DISABLED */9 :
        return "PERSON_CATEGORY_GUARDIAN_DISABLED";
    case /* PERSON_CATEGORY_GUARDIAN_ORPHANED */10 :
        return "PERSON_CATEGORY_GUARDIAN_ORPHANED";
    case /* PERSON_CATEGORY_ADOPTER */11 :
        return "PERSON_CATEGORY_ADOPTER";
    case /* PERSON_CATEGORY_CHILDREN */12 :
        return "PERSON_CATEGORY_CHILDREN";
    case /* PERSON_CATEGORY_MATERNITY */13 :
        return "PERSON_CATEGORY_MATERNITY";
    case /* PERSON_CATEGORY_CONVICT */14 :
        return "PERSON_CATEGORY_CONVICT";
    case /* PERSON_CATEGORY_MOTHER_MANY */15 :
        return "PERSON_CATEGORY_MOTHER_MANY";
    case /* PERSON_CATEGORY_STUDENT */16 :
        return "PERSON_CATEGORY_STUDENT";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "PERSON_CATEGORY_ADOPTER" :
        return /* PERSON_CATEGORY_ADOPTER */11;
    case "PERSON_CATEGORY_CHILDREN" :
        return /* PERSON_CATEGORY_CHILDREN */12;
    case "PERSON_CATEGORY_CONVICT" :
        return /* PERSON_CATEGORY_CONVICT */14;
    case "PERSON_CATEGORY_DISABLED_GROUP_1" :
        return /* PERSON_CATEGORY_DISABLED_GROUP_1 */3;
    case "PERSON_CATEGORY_DISABLED_GROUP_1_PERMANENT" :
        return /* PERSON_CATEGORY_DISABLED_GROUP_1_PERMANENT */4;
    case "PERSON_CATEGORY_DISABLED_GROUP_2" :
        return /* PERSON_CATEGORY_DISABLED_GROUP_2 */5;
    case "PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT" :
        return /* PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT */6;
    case "PERSON_CATEGORY_DISABLED_GROUP_3" :
        return /* PERSON_CATEGORY_DISABLED_GROUP_3 */7;
    case "PERSON_CATEGORY_GUARDIAN_DISABLED" :
        return /* PERSON_CATEGORY_GUARDIAN_DISABLED */9;
    case "PERSON_CATEGORY_GUARDIAN_ORPHANED" :
        return /* PERSON_CATEGORY_GUARDIAN_ORPHANED */10;
    case "PERSON_CATEGORY_MATERNITY" :
        return /* PERSON_CATEGORY_MATERNITY */13;
    case "PERSON_CATEGORY_MOTHER_MANY" :
        return /* PERSON_CATEGORY_MOTHER_MANY */15;
    case "PERSON_CATEGORY_PENSIONER_AGE" :
        return /* PERSON_CATEGORY_PENSIONER_AGE */1;
    case "PERSON_CATEGORY_PENSIONER_DUTY" :
        return /* PERSON_CATEGORY_PENSIONER_DUTY */2;
    case "PERSON_CATEGORY_STUDENT" :
        return /* PERSON_CATEGORY_STUDENT */16;
    case "PERSON_CATEGORY_UNSPECIFIED" :
        return /* PERSON_CATEGORY_UNSPECIFIED */0;
    case "PERSON_CATEGORY_VETERAN" :
        return /* PERSON_CATEGORY_VETERAN */8;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, PersonCategory, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "PersonCategory"
        ]]
    }, V1, {
      PersonCategory: PersonCategory
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "PersonCategory"
              ]]
          },
          "V1"
        ]]
    }, Control, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "PersonCategory"
                    ]]
                },
                "V1"
              ]]
          },
          "Control"
        ]]
    }, Tax, {
      Control: Control
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "PersonCategory"
                          ]]
                      },
                      "V1"
                    ]]
                },
                "Control"
              ]]
          },
          "Tax"
        ]]
    }, Buhta, {
      Tax: Tax
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
